import Delaunator from 'delaunator';
import { FACEMESH_UV_COORDS, FACEMESH_SILHOUETTE, FACEMESH_VERTEX_COUNT } from './facemeshConstants';

// Re-export for legacy imports.
export { FACEMESH_VERTEX_COUNT, FACEMESH_SILHOUETTE } from './facemeshConstants';

function pointInPolygon(x, y, poly) {
  // Ray casting; poly = array of [x,y]
  let inside = false;
  for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
    const xi = poly[i][0], yi = poly[i][1];
    const xj = poly[j][0], yj = poly[j][1];
    const intersect =
      ((yi > y) !== (yj > y)) &&
      (x < ((xj - xi) * (y - yi)) / (yj - yi + 1e-12) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
}

function buildCanonicalTriangles() {
  try {
    if (!Array.isArray(FACEMESH_UV_COORDS) || FACEMESH_UV_COORDS.length < FACEMESH_VERTEX_COUNT) return null;
    if (!Array.isArray(FACEMESH_SILHOUETTE) || FACEMESH_SILHOUETTE.length < 10) return null;

    const pts = FACEMESH_UV_COORDS.slice(0, FACEMESH_VERTEX_COUNT).map((p) => [p[0], p[1]]);
    const poly = FACEMESH_SILHOUETTE.map((idx) => {
      const p = pts[idx];
      return p ? [p[0], p[1]] : [0, 0];
    });

    const delaunay = Delaunator.from(pts);
    const tri = delaunay.triangles; // Uint32Array (3 * n)
    const kept = [];

    for (let i = 0; i < tri.length; i += 3) {
      const a = tri[i], b = tri[i + 1], c = tri[i + 2];
      if (a >= FACEMESH_VERTEX_COUNT || b >= FACEMESH_VERTEX_COUNT || c >= FACEMESH_VERTEX_COUNT) continue;
      const pa = pts[a], pb = pts[b], pc = pts[c];
      if (!pa || !pb || !pc) continue;

      // Keep triangles whose centroid is inside the silhouette (in canonical UV space).
      // This yields a dense, stable face mask and is intentionally a bit permissive near the boundary
      // (better occlusion coverage for temples than a strict "all-vertices-inside" test).
      const cx = (pa[0] + pb[0] + pc[0]) / 3;
      const cy = (pa[1] + pb[1] + pc[1]) / 3;
      if (!pointInPolygon(cx, cy, poly)) continue;

      kept.push(a, b, c);
    }

    if (kept.length < 1000) return null; // sanity
    return new Uint16Array(kept);
  } catch {
    return null;
  }
}

// Precompute once (module init). This is fast and avoids per-frame triangulation.
export const FACEMESH_OCCLUDER_TRIANGLES = buildCanonicalTriangles();

